import React from 'react';
import Icon from '@/v2/components/atoms/Icon';

import './Phone.scss';

const Phone = (props) => (
    <Icon iconName="Phone" {...props}>
        <svg viewBox="0 0 24 46" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="1440-/-Connectivity-/-Intro-01" transform="translate(-404.000000, -444.000000)" stroke="#000000" strokeWidth="1.5">
                    <g id="Ic_Phone" transform="translate(404.000000, 444.000000)">
                        <path
                            // eslint-disable-next-line
                            d="M18.9521353,44.8866647 L4.39719412,44.8866647 C2.52878235,44.8866647 1.01484118,43.3713706 1.01484118,41.5043118 L1.01484118,4.39719412 C1.01484118,2.52878235 2.52878235,1.01484118 4.39719412,1.01484118 L18.9521353,1.01484118 C20.8205471,1.01484118 22.3344882,2.52878235 22.3344882,4.39719412 L22.3344882,41.5043118 C22.3344882,43.3713706 20.8205471,44.8866647 18.9521353,44.8866647 Z"
                            id="Stroke-1"
                        />
                        <line x1="1.01443529" y1="40.8569294" x2="22.3340824" y2="40.8569294" id="Stroke-3" strokeLinecap="round" />
                        <line x1="4.98924118" y1="4.98274706" x2="18.3590059" y2="4.98274706" id="Stroke-5" strokeLinecap="round" />
                    </g>
                </g>
            </g>
        </svg>
    </Icon>
);

export default Phone;
